<template>
<!-- Mobile Menu Toggle -->
            <a class="mobile_btn" id="mobile_btn" >
                <i class="fas fa-bars"></i>
            </a>
            <!-- /Mobile Menu Toggle -->
</template>